var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExistingPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_116532)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1025_116532)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 99,
    r: 95,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.45 98.7593C108.753 98.7593 115.483 92.0285 115.483 83.7256C115.483 75.4227 108.753 68.6919 100.45 68.6919C92.1468 68.6919 85.416 75.4227 85.416 83.7256C85.416 92.0285 92.1468 98.7593 100.45 98.7593Z",
    fill: "#2B67AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9457 116.531C72.3415 117.259 72.0142 118.178 72.0216 119.125V127.193H128.887V119.018C128.897 118.071 128.57 117.151 127.963 116.424C124.514 112.582 120.261 109.545 115.507 107.531C110.753 105.516 105.614 104.572 100.454 104.767C95.2862 104.586 90.1419 105.546 85.3873 107.579C80.6327 109.612 76.3847 112.669 72.9457 116.531Z",
    fill: "#2B67AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.488 133.436C165.683 119.675 168.621 103.412 165.76 87.6526C162.9 71.893 154.433 57.701 141.923 47.6977C129.414 37.6944 113.707 32.5556 97.7044 33.2304C81.7015 33.9052 66.4833 40.348 54.8605 51.3688L59.0304 55.7666C69.5913 45.7527 83.419 39.8986 97.9597 39.2855C112.5 38.6723 126.772 43.3416 138.138 52.4309C149.505 61.5202 157.198 74.4154 159.797 88.735C162.397 103.055 159.727 117.831 152.281 130.336L157.488 133.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0599 68.1255C34.4835 82.2375 32.2696 98.6144 35.827 114.231C39.3845 129.849 48.4729 143.651 61.4138 153.089C74.3547 162.528 90.2738 166.964 106.231 165.58C122.188 164.196 137.106 157.084 148.228 145.558L143.867 141.35C133.761 151.823 120.206 158.285 105.707 159.542C91.2081 160.8 76.7435 156.769 64.985 148.193C53.2265 139.617 44.9685 127.076 41.7361 112.885C38.5037 98.6953 40.5153 83.8148 47.3994 70.9922L42.0599 68.1255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.642 138.296L150.452 113.022L172.435 125.494L150.642 138.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0186 57.2537L53.8706 82.5138L31.5687 70.6216L53.0186 57.2537Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1025_116532",
    x: -19.6,
    y: -20.6,
    width: 239.2,
    height: 239.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1025_116532"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1025_116532"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1025_116532",
    result: "effect2_dropShadow_1025_116532"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1025_116532",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_116532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingPatients);
export default __webpack_public_path__ + "static/media/ExistingPatients.4c4733a54ef45354425baa69680014be.svg";
export { ForwardRef as ReactComponent };